import React from "react";
import { I2cIcon } from "@webcomponents/i2cwebcomponents/dist/react";
import "../../Pages/PrepaidInstance/InstanceForms.scss";

const ReviewSearchEmptyState = () => {
  return (
    <div className="review-search-empty-state">
      <I2cIcon
        className="review-search-empty-icon"
        name="cs-linear-search"
      />
      <div>
        <div className="review-search-empty-title">
          No result found
        </div>
        <div className="review-search-empty-text">
          Try a different keyword, label, or numeric value.
        </div>
      </div>
    </div>
  );
};

export default ReviewSearchEmptyState;
